import NewsModel from "./newsModel";
export default class NewsModelList {
  news: NewsModel[];
  url: string;
}